import {useContext, useState} from 'react'
import MultiSelect from '../../../../components/MultiSelect/MultiSelect'
import {dataToSelectOptions} from '../../../../utils/common'
import {TimeSheetReportPageContext} from '../../context'
import {SideFilter} from '../../../../components/SideFilter'
import useSaveFilter from '../../hooks/useSaveFilter'
import PreDefinedDateRange from '../../../../components/DateRangePicker/PreDefinedDateRange'

const TimeSheetHeader = () => {
  const {
    projectsDropdownList,
    isLoadingProjectDropdownList,
    onProjectChange,
    onDateChange,
    filtersData,
    refetch,
    isLoadingTimeSheetData,
  } = useContext(TimeSheetReportPageContext)
  const options = dataToSelectOptions(projectsDropdownList, 'name', 'id')
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const {isOperationLoading, onSaveFilter} = useSaveFilter(refetch)

  return (
    <div className='d-flex justify-content-between mb-10'>
      <div>
        <MultiSelect
          id='product-status'
          className='w-250px'
          options={options}
          isLoading={isLoadingProjectDropdownList}
          defaultSelectedAll={true}
          allValuesSelectedText={'Project: All'}
          handleSelected={(values: any) => {
            const extractedValues = values.map((item: {value: string}) => item.value).join(',')
            onProjectChange(extractedValues)
          }}
        />
      </div>
      <div className='d-flex align-items-center gap-5'>
        <PreDefinedDateRange
          cb={onDateChange}
          exclude={['Current Year', 'Today', 'Yesterday', 'Last 7 Days']}
          maxRange={90}
          defaultValue={'Last 30 Days'}
          includeCurrantDay={true}
          isStoreDateInLocalStorage={false}
        />
        <div>
          <SideFilter
            filterData={filtersData}
            onApply={onSaveFilter}
            isOperationLoading={isOperationLoading || isLoadingTimeSheetData}
            onCancel={() => setIsDrawerOpen(false)}
            isDrawerOpen={isDrawerOpen}
            setIsDrawerOpen={setIsDrawerOpen}
            filterType={'project_timesheet_report'}
          />
        </div>
      </div>
    </div>
  )
}

export default TimeSheetHeader
